module.exports = __webpack_public_path__ + "img/evaluation-2018-review.ab4423f5.jpg";